import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Table, Modal } from "react-bootstrap";
import {
  onHandleHover,
  onHandleHoverDone,
  getDateColor,
  getLastUpdatedDateColor,
  getLastUpdatedTootlTip,
  getBookedVacationTooltip,
  sumHour,
  useSortableData
} from "../../../new-dashboard/dashboard-util/dashboard-utils";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import "../dashboard-consumer-retail.scss"
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import ProgressPill from "../../dashboard-shared/progress-pill/progress-pill";

// Custom Consumer Retail Dashboard Widget
const DashboardProjectTimeLog = (props) => {
  const [projects, setProjects] = useState(props.items ? props.items : null);
  const [show, setShow] = useState(false);
  const [selectedProject, setselectedProject] = useState(null);

  useEffect(() => {
    if (props.items) setProjects(props.items);
  }, [props]);

  const showModal = (m) => {
    setShow(true);
    setselectedProject(m)
  }

  const onHide = () => {
    setShow(true);
    setselectedProject(null)
  }

  const { items, requestSort, getArrowDirectionFor } = useSortableData(projects);

  const renderTable = (table) => {
    let result = null;
    if (table != null) {
      let sumCommingWeek = "-";
      let sumWeekend = "-"
      let sumTotal = "-"
      let sumLastWeek = "-"

      result = (
        <Table className="dashboard-table stickyTable">
          <thead className="header stickyHeader">
            <th>MEMBER</th>
            <th>EST. HOURS THIS COMING WEEK</th>
            <th>EST. WEEKEND HOURS</th>
            <th>TOTAL HOURS</th>
            <th>LAST WEEK HOURS</th>
            {getBookedVacationTooltip(<th>BOOKED VACATION</th>)}
            {getLastUpdatedTootlTip(<th>LAST UPDATED</th>)}
          </thead>
          <tbody>
            {table.map((tdata) => {
              sumCommingWeek = sumHour(sumCommingWeek, tdata.CurrentWeekHours?.Time);
              sumWeekend = sumHour(sumWeekend, tdata.WeekendHours?.Time);
              sumTotal = sumHour(sumTotal, tdata.TotalHours?.Time);
              sumLastWeek = sumHour(sumLastWeek, tdata.LastWeekHours?.Time);
              return (

                <tr>
                  <td className="text-break">{tdata.Name}</td>
                  <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.CurrentWeekHours?.Time ?? "-"}</td>
                  <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.WeekendHours?.Time ?? "-"}</td>
                  <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.TotalHours?.Time ?? "-"}</td>
                  <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"}>{tdata.LastWeekHours?.Time ?? "-"}</td>
                  <td className="text-break"
                    style={{ color: getDateColor(tdata.VacationPeriod?.DateRangeColor) }}>{tdata.VacationPeriod?.BookedVacation ?? "-"}</td>
                  <td className={(tdata.IsOldData ? "isOldData " : "") + "text-break"} style={{ color: tdata.IsOldData ? "":getLastUpdatedDateColor(tdata.LastUpdated) }}>{tdata.LastUpdated ?? "-"}</td>
                </tr>
              );
            })}

            <tr className="totalRow">
                <td className="text-break"><b>Total</b></td>
                <td className="text-break">{sumCommingWeek}</td>
                <td className="text-break">{sumWeekend}</td>
                <td className="text-break">{sumTotal}</td>

                <td className="text-break">{sumLastWeek}</td>
                <td className="text-break">-</td>
                <td className="text-break">-</td>
              </tr>
          </tbody>
        </Table>
      );

    }
    return result;
  };

  if (items != null && items.length > 0) {
    return (
      <div className="new-dashboard table-wrapper mt-4">
        <div className="DashboardTableWrapper">
          <div>
            <tr className="DashboardTableHeader">
              <th className="DashboardTableTitle">
                Project Time Log
                <p className="subDepartmentTitle">Consumer & Retail</p>
              </th>
            </tr>
          </div>
          <div className="scrollable-dashboard">
          <table>
              {/* Project and Deals table  */}
              <thead className="MemberTableColumnHeader sticky-header-dashboard">
                <tr className="tableColumnTitles tableHeader">
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('ClientName')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">CLIENT NAME</p>
                              </div>
                              {
                                getArrowDirectionFor("ClientName", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("ClientName", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("ClientName") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                  </th>
                  <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('Project.Name')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">PROJECT</p>
                              </div>
                              {
                                getArrowDirectionFor("Project.Name", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Project.Name", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Project.Name") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                            </div>
                  </th>
                  {/* <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                  <div className={'centerHead'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">MEMBERS</p>
                              </div>

                  </div>
                  </th> */}

                  <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                    <div onClick={() => requestSort('Project.Members')} className={'sortedCenter'}>
                        <div className="containerTextSorted">
                          <p className="textSorted">MEMBERS</p>
                        </div>
                        {
                          getArrowDirectionFor("Project.Members", "descending") && (
                            <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                          )
                        }
                        {
                          getArrowDirectionFor("Project.Members", "ascending") && (
                            <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                          )
                        }
                        {
                          getArrowDirectionFor("Project.Members") && (
                            <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                          )
                        }
                    </div>
                  </th>

                  <th className="col-md-2 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('Project.End')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">DUE DATE</p>
                              </div>
                              {
                                getArrowDirectionFor("Project.End", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Project.End", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("Project.End") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                  </div>
                  </th>
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('CurrentWeekHours')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">EST. HOURS THIS COMING WEEK</p>
                              </div>
                              {
                                getArrowDirectionFor("CurrentWeekHours", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("CurrentWeekHours", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("CurrentWeekHours") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                  </div>
                  </th>
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('WeekendHours')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">EST. WEEKEND HOURS</p>
                              </div>
                              {
                                getArrowDirectionFor("WeekendHours", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("WeekendHours", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("WeekendHours") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                  </div>
                  </th>
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('TotalHours')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">TOTAL HOURS</p>
                              </div>
                              {
                                getArrowDirectionFor("TotalHours", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalHours", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("TotalHours") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                  </div>
                  </th>
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                  <div onClick={() => requestSort('LastWeekHours')} className={'sortedCenter'}>
                              <div className="containerTextSorted">
                                <p className="textSorted">LAST WEEK HOURS</p>
                              </div>
                              {
                                getArrowDirectionFor("LastWeekHours", "descending") && (
                                  <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LastWeekHours", "ascending") && (
                                  <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                )
                              }
                              {
                                getArrowDirectionFor("LastWeekHours") && (
                                  <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                )
                              }
                  </div>
                  </th>

                  {getLastUpdatedTootlTip(
                  <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                    <div onClick={() => requestSort('LastUpdated')} className={'sortedCenter'}>
                                <div className="containerTextSorted">
                                  <p className="textSorted">LAST UPDATED</p>
                                </div>
                                {
                                  getArrowDirectionFor("LastUpdated", "descending") && (
                                    <img className="arrowDirection" alt="Arrow down" src={ArrowDown}/>
                                  )
                                }
                                {
                                  getArrowDirectionFor("LastUpdated", "ascending") && (
                                    <img className="arrowDirection" alt="Arrow up" src={ArrowUp}/>
                                  )
                                }
                                {
                                  getArrowDirectionFor("LastUpdated") && (
                                    <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover}/>
                                  )
                                }
                    </div>
                  </th>)}
                </tr>
              </thead>
              <tbody className="tableBody">
                {items &&
                  items.map((m) => {
                    return (
                      <tr key={m?.Project?.Id}>
                        <td className="col-md-1 col-sm-1 mt-2">
                          {m.ClientName}
                        </td>
                        <td className="col-md-2 col-sm-1 mt-2 hover"
                          onMouseLeave={(e) => onHandleHoverDone(e)}
                          onMouseEnter={(e) => onHandleHover(e)}
                          onClick={() => showModal(m)}>
                          {m.Project?.Name}
                        </td>
                        <td className="col-md-2 col-sm-1 mt-3">
                          <ViewMembersPanelNew
                            UserID={m.Project?.Owner?.Id}
                            members={m.Project?.Members}
                            projects={m.Project}
                            isHidden={true}
                          ></ViewMembersPanelNew>
                        </td>
                        <td className="col-md-2 col-sm-1 mt-2">
                          <ProgressPill start={m.Project?.Start} end={m.Project?.End} sortBy={"upcoming due dates"} />
                        </td>
                        <td className={(m.IsOldData ? "isOldData " : "") +"col-md-1 col-sm-1 mt-2"}>
                          {m.CurrentWeekHours?.Time ?? "-"}
                        </td>
                        <td className={(m.IsOldData ? "isOldData " : "") +"col-md-1 col-sm-1 mt-2"}>
                          {m.WeekendHours?.Time ?? "-"}
                        </td>
                        <td className={(m.IsOldData ? "isOldData " : "") +"col-md-1 col-sm-1 mt-2"}>
                          {m.TotalHours?.Time ?? "-"}
                        </td>
                        <td className={(m.IsOldData ? "isOldData " : "") +"col-md-1 col-sm-1 mt-2"}>
                          {m.LastWeekHours?.Time ?? "-"}
                        </td>
                        <td className={(m.IsOldData ? "isOldData " : "") +"col-md-1 col-sm-1 mt-2"} style={{ color: m.IsOldData ? "": getLastUpdatedDateColor(m.LastUpdated) }}>
                          {m.LastUpdated ?? "-"}
                        </td>                        
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {selectedProject && 
              <Modal
                show={show}
                onHide={onHide}
                contentClassName="dashboard-modal-styles"
                dialogClassName="dashboard-modal"
                scrollable={true}
              >
                <Modal.Header
                  className="dashboard-modal-header"
                  closeButton
                >
                  <Modal.Title className="dashboard-modal-title ml-4 ">
                    {selectedProject.Project?.Name}
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body className="scrollable">
                  {renderTable(selectedProject.MemberTimeLogs)}
                </Modal.Body>
              </Modal>}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

DashboardProjectTimeLog.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default DashboardProjectTimeLog;
